import TrailsList from "./TrailsList";

export default TrailsList;
